/**
 * GDPR soglasja v rezervacijskem popupu (.vivi-consent):
 * - #gdprall označi/odznači vse točke;
 * - točke nazaj sinhronizirajo #gdprall (vse → checked, del → indeterminate, nič → unchecked);
 * - ko uporabnik označi točko, ki je bila označena kot napaka (.form-error na label), napaka izgine.
 * Stili: src/styles/_vivi-consent.scss
 */
export default {
	init() {
		const all = document.getElementById('gdprall')
		if (!all) return

		const items = ['gdpr', 'gdprumop', 'gdprnl']
			.map((id) => document.getElementById(id))
			.filter(Boolean)
		if (!items.length) return

		const clearError = (input) => {
			const label = input.closest('label')
			if (label) label.classList.remove('form-error')
		}

		const syncAll = () => {
			const checked = items.filter((i) => i.checked).length
			all.checked = checked === items.length
			all.indeterminate = checked > 0 && checked < items.length
		}

		all.addEventListener('change', () => {
			items.forEach((i) => {
				i.checked = all.checked
				if (i.checked) clearError(i)
			})
			all.indeterminate = false
		})

		items.forEach((i) => {
			i.addEventListener('change', () => {
				if (i.checked) clearError(i)
				syncAll()
			})
		})

		syncAll()
	},
}
